export default __webpack_public_path__ + "static/Entenda0098-c975f91841f0e3403e1af602c6b60ee9.jpg";